import { Global as globalChannel } from '$lib/channels';
import { writable, readable, derived } from 'svelte/store';
import { dev } from '$app/environment';
import { page } from '$app/stores';

// Whether or not the schedule drawer is open in the UI
export const open = writable(true);

// Whether the window is below the mobile breakpoint 480px
export const mobile = writable(true);

// The list of possible genres
export const genres = writable();

// The currently selected channel
export const channel = writable();

export const currentChannel = derived([page, channel], ([$page, $channel]) => {
  if ($channel) {
    // console.log("returning selected channel", $channel)
    return $channel;
  } else {
    // console.log("$channel is", $channel)
    if ($page.route.id === '/music/[[slug]]') {
      const ch = $page.data.channels.find((c) => c.slug === $page.params.slug);
      // console.log("returning channel from slug", ch)
      channel.set(ch);
      return ch;
    } else {
      // console.log("returning global channel")
      return $page.data.globalChannel;
    }
  }
});

// Used for tests to dynamically switch off client side validation
export const clientSideValidationDisabled = writable(false);
